<template>
  <site-header></site-header> 
  <main class="main-content">
    <router-view />
  </main>
  <site-footer></site-footer>
</template>

<script>
import SiteHeader from "./components/SiteHeader.vue";
import SiteFooter from "./components/SiteFooter.vue";

export default {
  components: {
    SiteHeader,
    SiteFooter
  } 
};
</script>

<style lang="scss">
:root {
  --primary-color: #2a2a72;
  --secondary-color: #009ffd;
  --accent-color: #fca311;
  --text-color: #333;
  --light-text: #fafafa;
  --dark-bg: #1a1a2e;
  --light-bg: #f8f9fa;
  --font-main: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-main);
  line-height: 1.6;
  background-color: var(--light-bg);
  color: var(--text-color);
  overflow-x: hidden;
}

#app {  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  width: 100%;
}

a {
  text-decoration: none;
  color: var(--secondary-color);
  transition: color 0.3s ease;
  
  &:hover {
    color: var(--primary-color);
  }
}

.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

img {
  max-width: 100%;
  height: auto;
}

.phone {
  color: var(--light-text);
}

@media (max-width: 768px) {
  .container {
    width: 95%;
    padding: 0 0.5rem;
  }
}
</style>
